import React, { FC } from 'react';
import { isLastMonthDay } from '../../utils/utils';
import { CustomDayContentProps } from './CustomDayContent.model';

export const CustomDayContent: FC<CustomDayContentProps> = ({ day, date }) => {
  return (
    <div
      className={`inner-day-sphere ${
        isLastMonthDay(day, date) ? 'last-month-day' : ''
      }`}
    >
      {day}
    </div>
  );
};
